module.exports = __webpack_public_path__ + "img/poster.01fc8784.png";